import PageHeader from 'app/components/presentation/containers/page/PageHeader';
import PageWidth, { IPageWidthProps } from 'app/components/presentation/containers/page/PageWidth';
import { contentsStyles } from 'app/components/presentation/text/styles';
import { NumericBreakpoint } from 'app/constants/Breakpoints';
import { flexCascade, firefoxPrintHackStyles } from 'app/constants/Styles';
import { useClasses } from 'app/utils/css';
import React, { ReactNode } from 'react';
import { usePageBreakpoint } from 'app/components/layout/Breakpoint';

interface IProps {
  children: ReactNode;
  header?: ReactNode;
  maxWidth?: IPageWidthProps['maxWidth'];
}

/**
 * Helper to wrap Page content.
 */
const PageContent = ({ children, header, maxWidth = '1200px' }: IProps) => {
  const breakpoint = usePageBreakpoint();
  const classes = useClasses({
    container: {
      ...flexCascade,
      boxSizing: 'border-box',
      margin: '0 auto',
      width: '100%',
      '@media print': firefoxPrintHackStyles,
    },

    content: {
      ...contentsStyles,
      ...flexCascade,
    },

    paddingWrapper: {
      ...flexCascade,
      padding: breakpoint <= NumericBreakpoint.Wide ? '60px 5px' : '60px 16px',
    },
  });

  return (
    <div className={classes.paddingWrapper}>
      <PageWidth maxWidth={maxWidth}>
        <section className={classes.container}>
          <PageHeader header={header}>
            <div className={classes.content}>
              {children}
            </div>
          </PageHeader>
        </section>
      </PageWidth>
    </div>
  );
};

export default PageContent;
